import { useQuery } from '@tanstack/react-query';
import * as dashboardApi from '@/api/dashboard';
import type { DashboardStudentsListParams } from '@/types/dashboard';
import type { DashboardAssignmentsListParams } from '@/types/assignment';

export function useDashboardOverview() {
  return useQuery({
    queryKey: ['dashboard', 'overview'],
    queryFn: dashboardApi.getOverview,
  });
}

export function useDashboardStudents(params?: DashboardStudentsListParams) {
  return useQuery({
    queryKey: ['dashboard', 'students', params],
    queryFn: () => dashboardApi.getStudents(params),
  });
}

export function useStudentDetail(id: string) {
  return useQuery({
    queryKey: ['dashboard', 'students', id],
    queryFn: () => dashboardApi.getStudentDetail(id),
    enabled: !!id,
  });
}

export function useDashboardAssignments(params?: DashboardAssignmentsListParams) {
  return useQuery({
    queryKey: ['dashboard', 'assignments', params],
    queryFn: () => dashboardApi.getAssignments(params),
  });
}

export function useSearchDashboardStudents(search: string) {
  return useQuery({
    queryKey: ['dashboard', 'students', 'search', search],
    queryFn: () => dashboardApi.searchStudents(search),
    enabled: search.length >= 2,
    placeholderData: (prev) => prev,
  });
}

export function useSearchPracticeSeeds(search: string) {
  return useQuery({
    queryKey: ['dashboard', 'practice-seeds', 'search', search],
    queryFn: () => dashboardApi.searchPracticeSeeds(search),
    enabled: search.length >= 2,
    placeholderData: (prev) => prev,
  });
}
